import Vue from "vue";
import {
	postAction
} from "../api/api";
import {
	TypeList
} from "../api/url";
import qs from "qs";
import {
	Message
} from "element-ui";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Organization from "../views/library/Organization/index.vue"; // 创新平台(机构库)
import OrganizationDetail from "../views/library/Organization/detail.vue"; // 创新平台(机构库)
import activity from "../views/library/activity/index.vue"; // 科技活动
import activityDetail from "../views/library/activity/detail.vue"; // 科技活动
import demand from "../views/library/demand/index.vue"; // 需求
import demandDetail from "../views/library/demand/detail.vue"; // 需求
import fruit from "../views/library/fruit/index.vue"; // 成果
import talent from "../views/library/talent/index.vue"; // 人才
import school from "../views/library/school/index.vue"; // 高校
import flowChart from "../views/library/flowChart/index.vue"; // 流程图
import talentPoolinfo from "../views/library/talent/talentPoolinfo.vue";
import schoolInfo from "../views/library/school/schoolInfo.vue";
import creativeTalents from "../views/library/school/creativeTalents.vue";
import zdyf from "../views/library/school/zdyf.vue";
import lectureRoomDetail from "../views/library/school/lectureRoomDetail.vue";
import zjDetails from "../views/library/school/zjDetails.vue";
import research from "../views/library/school/research.vue";
import lectureRoom from "../views/library/school/lectureRoom.vue";
import Assume from "../views/Assume"; // 揭榜挂帅
import LeftNotice from "../views/AssumeData/LeftNotice"; // 左侧通知
import RightNotice from "../views/AssumeData/RightNotice"; //右侧通知
import NewsInfo from "../views/AssumeData/NewsInfo"; // 新闻详情页面
import publicity from "../views/AssumeData/publicity"; // 新闻详情页面
import Resolve from "../views/AssumeData/Resolve"; //签约项目
import ZbData from "../views/AssumeData/ZbData"; //张榜项目
import NewMap from "../views/NewMap"; //创新地图
import qitj from "../views/qitj"; //政策体检
import result from "../views/result"; //政策体检-公司信息
import CloudShow from "../views/CloudShow/index"; //云展厅
import yunDetail from "../views/CloudShow/yunDetail.vue"; //云路演详情
import resultDialogcopy from "../views/CloudShow/resultDialogcopy.vue"; //成果厅详情
import demandDialogCopy from "../views/CloudShow/demandDialogCopy.vue"; //需求厅复制链接页面
import moreZbitems from "../views/AssumeData/moreZbitems"; //张榜项目更多
import moreQyItems from "../views/AssumeData/moreQyItems"; //签约项目更多
import AboutInform from "../views/AssumeData/AboutInform"; //新闻更多
import AboutPublicity from "../views/AssumeData/AboutPublicity"; //新闻更多
import SearchData from "../views/searchData";
import seach from "../views/seach";

import Register from "../views/Register";
import fruitDetail from "../views/library/fruit/detail.vue"; // 成果
import scienceLoan from "../views/SpecialServe/scienceLoan.vue";
import contractLogin from "../views/SpecialServe/contractLogin.vue";
import FindPassword from "../views/FindPassword.vue";
import weChatLogin from "../views/weChatLogin";
import Login from "../components/Login";
import SharePage from "../views/Mobile/SharePage";
import fruitt from "../views/library/school/fruitt.vue";
import demandSchool from "../views/library/school/demandSchool.vue";
import jx from "../views/library/jxcg/jx.vue";
import fruittDetail from "../views/library/school/fruittDetail.vue";
Vue.use(VueRouter);

const routes = [{
		path: "/",
		name: "河南省科技成果转移转化公共服务平台",
		component: Home,
		redirect: "Index",
		children: [{
				path: "/aboutUs",
				name: "关于我们",
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () =>
					import( /* webpackChunkName: "about" */ "../views/AboutUs.vue"),
			},
			{
				path: "/callUs",
				name: "联系我们",
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () =>
					import( /* webpackChunkName: "about" */  "../views/callUs.vue"),
			},
			{
				path: "/Index",
				name: "河南省科技成果转移转化公共服务平台",
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () =>
					import( /* webpackChunkName: "about" */ "../views/Index.vue"),
			},
			{
				path: "/Organization",
				name: "创新平台",
				component: Organization,
			},
			{
				path: "/OrganizationDetail",
				name: "创新平台详情",
				component: OrganizationDetail,
			},
			{
				path: "/activity",
				name: "科技活动",
				component: activity,
			},
			{
				path: "/activityDetail",
				name: "科技活动详情",
				component: activityDetail,
			},
			{
				path: "/demand",
				name: "技术需求库",
				component: demand,
			},
			{
				path: "/fruit",
				name: "技术成果库",
				component: fruit,
			},
			{
				path: "/talent",
				name: "高层次人才库",
				component: talent,
			},
			{
				path: "/school",
				name: "高校",
				component: school,
			},
			{
				path: "/publicity",
				name: "鉴证详情",
				component: publicity,
			},
			{
				path: "/flowChart",
				name: "流程图",
				component: flowChart,
			},

			{
				path: "/schoolInfo",
				name: "高校详情",
				component: schoolInfo,
			},
			{
				path: "/research",
				name: "重点研发平台",
				component: research,
			},
			{
				path: "/creativeTalents",
				name: "高校创新人才",
				component: creativeTalents,
			},
			{
				path: "/zdyf",
				name: "重点研发",
				component: zdyf,
			},
			
			{
				path: "/lectureRoom",
				name: "成果讲堂",
				component: lectureRoom,
			},
			{
				path: "/fruitt",
				name: "技术",
				component: fruitt,
			},
			{
				path: "/demandSchool",
				name: "需求",
				component: demandSchool,
			},
			{
				path: "/jx",
				name: "精选",
				component: jx,
			},
			{
				path: "/fruittDetail",
				name: "成果详情",
				component: fruittDetail,
			},
			{
				path: "/lectureRoomDetail",
				name: "成果讲堂详情",
				component: lectureRoomDetail,
			},

			{
				path: "/talentPoolinfo",
				name: "高层次人才详情",
				component: talentPoolinfo,
			},
			{
				path: "/Assume",
				name: "揭榜挂帅",
				component: Assume,
			},
			{
				path: "/LeftNotice",
				name: "通知详情",
				component: LeftNotice,
			},
			{
				path: "/RightNotice",
				name: "通知详情",
				component: RightNotice,
			},
			{
				path: "/NewsInfo",
				name: "新闻详情",
				component: NewsInfo,
			},
			{
				path: "/Resolve",
				name: "签约项目详情",
				component: Resolve,
			},
			{
				path: "/ZbData",
				name: "张榜项目详情",
				component: ZbData,
			},

			{
				path: "/NewMap",
				name: "创新地图",
				component: NewMap,
			},
			{
				path: "/qitj",
				name: "企业体检",
				component: qitj,
			},
		 {
				path: "/AboutPublicity",
				name: "公式鉴证",
				component: AboutPublicity,
			},
			{
				path: "/result",
				name: "单位信息",
				component: result,
			},
			{
				path: "/CloudShow",
				name: "云展厅",
				component: CloudShow,
			},
			{
				path: "/yunDetail",
				name: "云路演",
				component: yunDetail,
			},
			{
				path: "/resultDialogcopy",
				name: "成果厅详情页面",
				component: resultDialogcopy,
			},
			{
				path: "/demandDialogCopy",
				name: "需求厅详情页面",
				component: demandDialogCopy,
			},
			{
				path: "/moreZbitems",
				name: "张榜项目更多",
				component: moreZbitems,
			},
			{
				path: "/moreQyItems",
				name: "签约项目更多",
				component: moreQyItems,
			},
			{
				path: "/AboutInform",
				name: "新闻更多",
				component: AboutInform,
			},
			{
				path: "/SearchData",
				name: "搜索结果",
				component: SearchData,
			},
			{
				path: "/seach",
				name: "搜索",
				component: seach,
			},
			{
				path: "/Register",
				name: "注册",
				component: Register,
			},
			{
				path: "/fruitDetail",
				name: "成果详情",
				component: fruitDetail,
			},
			{
				path: "/zjDetails",
				name: "成果专家详情",
				component: zjDetails,
			},
			{
				path: "/contractLogin",
				name: "特色服务-技术合同登记",
				component: contractLogin,
			},
			{
				path: "/scienceLoan",
				name: "特色服务-科技贷",
				component: scienceLoan,
			},
			{
				path: "/demandDetail",
				name: "需求详情",
				component: demandDetail,
			},
		],
	},
	{
		path: "/findPsd",
		name: "找回密码",
		component: FindPassword,
	},
	{
		path: "/weChatLogin",
		name: "找回密码",
		component: weChatLogin,
	},
	{
		path: "/Login",
		name: "登录",
		component: Login,
	},
	{
		path: "/SharePage",
		name: "分享页",
		component: SharePage,
	},
];

const router = new VueRouter({
	routes,
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch((err) => err);
};

router.beforeEach((to, from, next) => {
	//// console.log(to);
	document.title = to.name;
	var url2=window.location.origin+window.location.pathname+'#'+to.path;
	window.scrollTo(0, 0);
	if (to.path == "/Index" || to.path == "/") {
		localStorage.setItem("NowIndex", 0);
	} else if (to.path == "/demandDetail") {
		localStorage.setItem("NowIndex", 2);
	} else if (to.path == "/talentPoolinfo") {
		localStorage.setItem("NowIndex", 3);
	} else if (to.path == "/fruitDetail") {
		localStorage.setItem("NowIndex", 1);
	} else if (to.path == "/OrganizationDetail") {
		localStorage.setItem("NowIndex", 4);
	}else if (to.path == "/schoolInfo") {
		localStorage.setItem("NowIndex", 5);
	} 
	else if (to.path == "/creativeTalents") {
		localStorage.setItem("NowIndex", 6);
	} 
	
	else if (to.path == "/lectureRoom") {
		localStorage.setItem("NowIndex", 7);
	} 
	else if (to.path == "/zjDetails") {
		localStorage.setItem("NowIndex", 8);
	} 
	else if (to.path == "/zdyf") {
		localStorage.setItem("NowIndex", 9);
	} 
	//  next();
	// } else {
	//   alert("系统维护中。。。");
	// }
	let data = {
		action: "Add_WebVisits",
		url: url2,
		title: document.title,
		Field3: "PC端",
	};
	postAction(TypeList, qs.stringify(data)).then((res) => {});
	setTimeout(() => {
		next();
	}, 400);
});

export default router;
